import { render, staticRenderFns } from "./addVehicleChallan.vue?vue&type=template&id=3547b90b"
import script from "./addVehicleChallan.vue?vue&type=script&lang=js"
export * from "./addVehicleChallan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports